import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Logótipo oficial Trabadju.
 * variant: 'dark' (fundo claro → logo cores) | 'light' (fundo escuro → logo branco)
 * size:    'xs'|'sm'|'md'|'lg'|'xl'
 * asLink:  bool (default true)
 */
function TrabdjuLogo({ size = 'md', variant = 'dark', asLink = true, className = '' }) {
  // height classes  xs=24px sm=32px md=40px lg=48px xl=56px
  const h = { xs: 'h-6', sm: 'h-8', md: 'h-10', lg: 'h-12', xl: 'h-14' }[size] || 'h-10';

  const svgSrc = variant === 'light'
    ? '/logos/trabadju_logo_branco.svg'
    : '/logos/trabadju_logo_cores.svg';
  const pngSrc = variant === 'light'
    ? '/logos/trabadju_logo_branco.png'
    : '/logos/trabadju_logo_cores.png';

  const imgEl = (
    <picture>
      <source srcSet={svgSrc} type="image/svg+xml" />
      <img
        src={pngSrc}
        alt="Trabadju"
        className={`${h} w-auto object-contain select-none ${className}`}
        draggable={false}
        data-testid={variant === 'light' ? 'logo-branco' : 'logo-cores'}
      />
    </picture>
  );

  if (!asLink) return imgEl;

  return (
    <Link to="/" data-testid="nav-brand" className="flex items-center hover:opacity-90 transition-opacity">
      {imgEl}
    </Link>
  );
}

export default TrabdjuLogo;
export { TrabdjuLogo };
